module.exports = __webpack_public_path__ + "img/signature-violetAmethyste.55019796.png";